import React from "react";
import _ from "lodash";
import { connect } from "react-redux";
import glamorous from "glamorous";
import { InputGroup, DropdownButton, MenuItem, Button } from "react-bootstrap";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import "../../styles/App.css";

import Search from "react-icons/lib/fa/search";

import FilterSection from "./FilterSection";
import SearchState from "./ShipmentSearchState";
import DomainDataState from "../domain-data/DomainDataState";
import Colors from "../../styles/colors";
import LadsState from "../lads/LadsState";
import { selectLocationsAlphabetically } from "../locations/LocationsState";

const TypeaheadOption = ({ option }) => {
  return (
    <glamorous.Div
      css={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItmes: "flex-end"
      }}
    >
      <glamorous.Div
        css={{
          color: Colors.text.GRAY,
          fontSize: "small",
          fontStyle: "italic",
          marginRight: "1em"
        }}
      >
        {option.categoryLabel}
      </glamorous.Div>
      {option.label}
    </glamorous.Div>
  );
};

class SearchComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      typeaheadOptions: [],
      isLoading: false
    };

    this.constructTypeaheadOptions = this.constructTypeaheadOptions.bind(this);

    this.partOptions = [];
    this.locationOptions = [];
    this.shipmentOptions = [];
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.searchCategory !== nextProps.searchCategory) {
      this.constructTypeaheadOptions(
        nextProps.searchObj.label,
        nextProps.searchCategory
      );
    }
    if (this.props.searchObj.label && !nextProps.searchObj.label) {
      this.typeahead.getInstance().clear();
    }

    // Because of the number of parts, construct this
    // map outside of the render loop for increased performance
    if (this.props.parts !== nextProps.parts) {
      this.constructPartLookup(nextProps.parts);
    }
    if (this.props.locations !== nextProps.locations) {
      this.constructLocationLookup(nextProps.locations);
    }
    if (this.props.shipmentIDs !== nextProps.shipmentIDs) {
      this.constructShipmentLookup(nextProps.shipmentIDs);
    }
  }

  componentDidMount() {
    this.constructPartLookup(this.props.parts);
    this.constructLocationLookup(this.props.locations);
    this.constructShipmentLookup(this.props.shipmentIDs);
  }

  constructPartLookup(parts) {
    this.partOptions = parts.map(p => {
      return {
        label: p,
        value: p,
        category: "part_number",
        categoryLabel: "Part #"
      };
    });
  }

  constructLocationLookup(locations) {
    this.locationOptions = locations.map(l => {
      return {
        label: `${l.name} (${l.code})`,
        value: l.id,
        category: "location",
        categoryLabel: "Location"
      };
    });
  }
  constructShipmentLookup(shipments) {
    this.shipmentOptions = shipments.map(s => {
      return {
        label: s,
        value: s,
        category: "shipment_id",
        categoryLabel: "Shipment ID"
      };
    });
  }

  constructTypeaheadOptions(query, searchCategory) {
    // If our query is empty, don't do anything
    // otherwise we load everything into the lookahead
    // and the system gets into a bad state
    if (query.length < 1) {
      return;
    }

    this.setState({ isLoading: true });

    let typeaheadOptions = [];
    if (
      this.locationOptions.length > 0 &&
      (searchCategory === "location" || searchCategory === "everything")
    ) {
      typeaheadOptions = typeaheadOptions.concat(this.locationOptions);
    }
    if (
      this.shipmentOptions.length > 0 &&
      (searchCategory === "shipment_id" || searchCategory === "everything")
    ) {
      typeaheadOptions = typeaheadOptions.concat(this.shipmentOptions);
    }
    if (
      this.partOptions.length > 0 &&
      (searchCategory === "part_number" || searchCategory === "everything")
    ) {
      typeaheadOptions = typeaheadOptions.concat(this.partOptions);
    }

    typeaheadOptions = typeaheadOptions.filter(o =>
      o.label.toLowerCase().includes(query.toLowerCase())
    );
    this.setState({ typeaheadOptions, isLoading: false });
  }

  render() {
    const { typeaheadOptions, isLoading } = this.state;
    const {
      searchObj,
      searchCategory,
      searchFilters,
      setSearch,
      setSearchCategory,
      searchShipments,
      pushSearchView
    } = this.props;

    return (
      <InputGroup
        style={{
          border: "1px solid rgba(0, 0, 0, 0.1)",
          boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.1)",
          borderRadius: "3px"
        }}
      >
        <Search
          style={{
            color: Colors.text.RIVER_BED,
            position: "absolute",
            left: "0.8em",
            top: "0.85em",
            zIndex: 1
          }}
        />
        <AsyncTypeahead
          ref={typeahead => (this.typeahead = typeahead)}
          useCache={false}
          className="custom-typeahead"
          defaultInputValue={searchObj.label}
          options={typeaheadOptions}
          emptyLabel={false}
          selectHintOnEnter={true}
          maxResults={5}
          onInputChange={e => setSearch(e, e)}
          onChange={e => {
            if (e.length > 0) {
              setSearch(e[0].label, e[0].value);
              setSearchCategory(e[0].category);
              searchShipments(
                { label: e[0].label, value: e[0].value },
                e[0].category,
                searchFilters
              );
              pushSearchView();
            }
          }}
          onSearch={q => this.constructTypeaheadOptions(q, searchCategory)}
          isLoading={isLoading}
          placeholder={
            SearchState.SEARCH_CATEGORIES[searchCategory].placeholder
          }
          renderMenuItemChildren={option => <TypeaheadOption option={option} />}
          inputProps={{
            style: {
              backgroundColor: "white",
              border: "none",
              boxShadow: "none",
              flex: 1,
              height: "2.8em",
              padding: "1em",
              paddingLeft: "2.4em",
              borderRadius: "3px",
              zIndex: 0,
              width: "100%"
            }
          }}
        />
        <DropdownButton
          componentClass={InputGroup.Button}
          id="input-dropdown-addon"
          title={SearchState.SEARCH_CATEGORIES[searchCategory].label}
          style={{
            display: "flex",
            height: "2.8em",
            width: "11.25em",
            justifyContent: "space-between",
            alignItems: "center",
            border: "none",
            backgroundColor: Colors.background.LIGHT_GRAY
          }}
        >
          {Object.keys(SearchState.SEARCH_CATEGORIES).map(c => (
            <MenuItem key={c} eventKey={c} onSelect={k => setSearchCategory(k)}>
              {SearchState.SEARCH_CATEGORIES[c].label}
            </MenuItem>
          ))}
        </DropdownButton>
      </InputGroup>
    );
  }
}

const AdvancedSearchButton = glamorous.div(
  {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "9em",
    height: "3.5em",
    borderRadius: "3px",
    fontStyle: "italic",
    ":hover": { cursor: "pointer", color: Colors.background.DARK_BLUE }
  },
  ({
    showFilters = false,
    backgroundColor = Colors.background.LIGHT_GRAY
  }) => ({
    borderBottomRightRadius: showFilters ? "0px" : "3px",
    borderBottomLeftRadius: showFilters ? "0px" : "3px",
    backgroundColor: showFilters ? backgroundColor : "none",
    textDecoration: showFilters ? "none" : "underline"
  })
);

class ShipmentSearchBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showFilters: props.showFilters
    };
  }

  componentWillReceiveProps(nextProps) {
    const { searchFilters, searchShipments } = this.props;

    if (!_.isEqual(nextProps.searchFilters, searchFilters)) {
      searchShipments(
        nextProps.searchObj,
        nextProps.searchCategory,
        nextProps.searchFilters
      );
    }
  }

  render() {
    const { showFilters } = this.state;
    const {
      searchObj,
      searchCategory,
      searchFilters,
      searchShipments,
      pushSearchView,
      locations,
      exceptionTypes,
      statusTypes,
      shipmentModes,
      carriers,
      backgroundColor,
      lads,
      organizations
    } = this.props;

    return (
      <div>
        <glamorous.Div
          css={{
            display: "flex",
            flexDirection: "row"
          }}
        >
          <SearchComponent {...this.props} />
          <Button
            style={{
              display: "inline-block",
              backgroundColor: Colors.background.DARK_BLUE,
              color: "white",
              height: "3em",
              marginLeft: "0.5em",
              marginRight: "0.5em",
              paddingLeft: "2em",
              paddingRight: "2em"
            }}
            onClick={() => {
              searchShipments(searchObj, searchCategory, searchFilters);
              pushSearchView();
            }}
          >
            Search
          </Button>
          <AdvancedSearchButton
            showFilters={showFilters}
            backgroundColor={backgroundColor}
            onClick={() => this.setState({ showFilters: !showFilters })}
          >
            <glamorous.Div css={{ marginTop: "-5px" }}>
              Advanced Search
            </glamorous.Div>
          </AdvancedSearchButton>
        </glamorous.Div>
        <FilterSection
          show={showFilters}
          locations={locations}
          exceptionTypes={exceptionTypes}
          statusTypes={statusTypes}
          shipmentModes={shipmentModes}
          carriers={carriers}
          backgroundColor={backgroundColor}
          lads={lads}
          organizations={organizations}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    searchObj: SearchState.selectors.getSearchObj(state),
    searchCategory: SearchState.selectors.getSearchCategory(state),
    searchFilters: SearchState.selectors.getSearchFilters(state),
    locations: selectLocationsAlphabetically(state),
    exceptionTypes: DomainDataState.selectors.selectExceptionTypesAlphabetically(
      state
    ),
    statusTypes: DomainDataState.selectors.selectStatusTypesAlphabetically(
      state
    ),
    shipmentModes: DomainDataState.selectors.selectShipmentModesAlphabetically(
      state
    ),
    carriers: DomainDataState.selectors.selectCarriersAlphabetically(state),
    shipmentIDs: DomainDataState.selectors.getShipmentIDs(state),
    parts: DomainDataState.selectors.getParts(state),
    lads: LadsState.selectors.selectLadsListAlphabetically(state),
    organizations: state.organizations.data
      ? state.organizations.data.response
      : state.organizations.data
  };
}

function mapDispatchToProps(dispatch) {
  return {
    pushSearchView: () => dispatch({ type: "SHIPMENT_SEARCH" }),
    searchShipments: (searchObj, searchCategory, searchFilters) =>
      dispatch(
        SearchState.actionCreators.searchShipments(
          searchObj,
          searchCategory,
          searchFilters
        )
      ),
    setSearch: (label, value) =>
      dispatch(SearchState.actionCreators.setSearch(label, value)),
    setSearchCategory: searchCategory =>
      dispatch(SearchState.actionCreators.setSearchCategory(searchCategory))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShipmentSearchBar);



// WEBPACK FOOTER //
// ./src/modules/shipment-search/ShipmentSearchBar.js